export default "__VITE_ASSET__pxp8pSpi__"